import { useEffect } from 'react'
import HeadMeta from 'components/common/HeadMeta'
import JsonLd, { quickPageMeta, quickSchema } from 'components/common/schema'
import Template from 'components/cases/quick'

const Quick: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.add('non-chat')
  }, [])
  return (
    <>
      <HeadMeta {...quickPageMeta} />
      <JsonLd data={quickSchema} />
      <Template />
    </>
  )
}

export default Quick
